export const config = {
  propsName: 'renderProps',
  name: 'SpActiveTextarea',
  type: 'activeTmpsConfig',
  icon: 'el-icon-document',
  cnName: '文本域',
  tooltip: 'SpTmp模版tooltip',
  base: {
    margin: [0, 0, 0, 0],
    textarea: ''
  },
  props: [
    {
      type: 'el-input',
      key: 'textarea',
      bind: {
        label: '文本内容',
        placeholder: '请输入文本内容',
        type: 'textarea'
      },
      value: ''
    },
    {
      // tooltip:'背景图的tooltip',
      type: () => import('@/weappTmps/comps/color/index.vue'),
      cmpPath: '/comps/color/index.vue',
      key: 'color',
      bind: {
        label: '字体颜色'
      },
      on: {},
      value: null
    },
    {
      tooltip: 'fontWeight',
      type: () => import('@/weappTmps/comps/fontWeight/index.vue'),
      cmpPath: '/comps/fontWeight/index.vue',
      key: 'fontWeight',
      bind: {
        // label: '排列方式',
      },
      on: {},
      value: null
    },
    {
      // tooltip:'背景图的tooltip',
      type: () => import('@/weappTmps/comps/backgroundColor/index.vue'),
      cmpPath: '/comps/backgroundColor/index.vue',
      key: 'backgroundColor',
      bind: {
        label: '背景色'
      },
      on: {},
      value: null
    },

    {
      type: () => import('@/weappTmps/comps/margin/index.vue'),
      cmpPath: '/comps/margin/index.vue',
      key: 'margin',
      bind: {
        label: '边距'
      },
      on: {},
      value: [0, 0, 0, 0]
    }
  ]
}
